import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import ISolicitor from './ISolicitor';

export function solicitorsSelector(state: IGlobalState): IDictionary<ISolicitor> {
    return state.solicitors.solicitors;
}
